import { defaultProps, compose } from 'recompose';
import { mapValues } from 'lodash';
import Components from 'components';
import AffiliatesContainer from 'containers/AffiliatesContainer/AffiliatesContainer';
import AlertContainer from 'containers/AlertContainer/AlertContainer';
import CartButtonContainer from 'containers/CartButtonContainer/CartButtonContainer';
import CardListContainer from 'containers/CardListContainer/CardListContainer';
import CardProductContainer from 'containers/CardProductContainer/CardProductContainer';
import DesigneeSearchContainer from 'containers/DesigneeSearchContainer/DesigneeSearchContainer';
import ExpandableListItemContainer from 'containers/ExpandableListItemContainer/ExpandableListItemContainer';
import GraphQLContainer from 'containers/GraphQLContainer/GraphQLContainer';
import ImportProductContainer from 'containers/ImportProductContainer/ImportProductContainer';
import PackageTabBContainer from 'containers/PackageTabBContainer/PackageTabBContainer';
import ProductSearchContainer from 'containers/ProductSearchContainer/ProductSearchContainer';
import SelectContainer from 'containers/SelectContainer/SelectContainer';
import SeminarSchedulerContainer from 'containers/SeminarSchedulerContainer/SeminarSchedulerContainer';

const containers = {
  // Add containers to be exported
  AlertContainer,
  CartButtonContainer,
  CardListContainer,
  CardProductContainer,
  ExpandableListItemContainer,
  ImportProductContainer,
  PackageTabBContainer,
  ProductSearchContainer,
  SelectContainer,
  SeminarSchedulerContainer,
};

const gravitonConsumers = {
  // Add containers to be exported
  DesigneeSearchContainer: compose(GraphQLContainer)(DesigneeSearchContainer),
  AffiliatesContainer: compose(GraphQLContainer)(AffiliatesContainer),
};

// Pass type property to each container
const recomposed = mapValues(containers, (value, key) => defaultProps({ type: key })(value), {});

export default {
  ...Components,
  ...recomposed,
  ...gravitonConsumers,
};
